export var PrimoPlus = [
    // 0-16
    { PrimoPlus: { '0': 188.51, '300': 169.31, '600': 115.2, '1200': 78.74 } },
    // 17-20
    { PrimoPlus: { '0': 221.38, '300': 197.64, '600': 164.5, '1200': 131.15 } },
    // 21
    { PrimoPlus: { '0': 359.56, '300': 338.69, '600': 305.04, '1200': 247.79 } },
    // 22
    { PrimoPlus: { '0': 367.64, '300': 347.14, '600': 313.2, '1200': 254.68 } },
    // 23
    { PrimoPlus: { '0': 375.92, '300': 355.78, '600': 321.44, '1200': 261.65 } },
    // 24
    { PrimoPlus: { '0': 384.18, '300': 364.41, '600': 329.62, '1200': 268.54 } },
    // 25
    { PrimoPlus: { '0': 392.54, '300': 373.13, '600': 337.73, '1200': 275.42 } },
    // 26
    { PrimoPlus: { '0': 400.93, '300': 381.86, '600': 345.79, '1200': 282.26 } },
    // 27
    { PrimoPlus: { '0': 409.36, '300': 390.62, '600': 353.85, '1200': 289.11 } },
    // 28
    { PrimoPlus: { '0': 417.91, '300': 399.49, '600': 361.94, '1200': 296 } },
    // 29
    { PrimoPlus: { '0': 426.54, '300': 408.45, '600': 370.09, '1200': 302.92 } },
    // 30
    { PrimoPlus: { '0': 435.01, '300': 417.23, '600': 378.09, '1200': 309.73 } },
    // 31
    { PrimoPlus: { '0': 443.19, '300': 425.7, '600': 385.82, '1200': 316.3 } },
    // 32
    { PrimoPlus: { '0': 451.22, '300': 434.01, '600': 393.43, '1200': 322.77 } },
    // 33
    { PrimoPlus: { '0': 459.14, '300': 442.21, '600': 400.98, '1200': 329.18 } },
    // 34
    { PrimoPlus: { '0': 467.1, '300': 450.43, '600': 408.55, '1200': 335.61 } },
    // 35
    { PrimoPlus: { '0': 475.33, '300': 458.95, '600': 416.39, '1200': 342.27 } },
    // 36
    { PrimoPlus: { '0': 483.95, '300': 467.85, '600': 424.56, '1200': 349.25 } },
    // 37
    { PrimoPlus: { '0': 492.98, '300': 477.18, '600': 433.09, '1200': 356.58 } },
    // 38
    { PrimoPlus: { '0': 502.51, '300': 487.03, '600': 442.07, '1200': 364.34 } },
    // 39
    { PrimoPlus: { '0': 512.61, '300': 497.46, '600': 451.58, '1200': 372.57 } },
    // 40
    { PrimoPlus: { '0': 523, '300': 508.19, '600': 461.36, '1200': 381.08 } },
    // 41
    { PrimoPlus: { '0': 533.62, '300': 519.15, '600': 471.39, '1200': 389.83 } },
    // 42
    { PrimoPlus: { '0': 544.45, '300': 530.35, '600': 481.66, '1200': 398.82 } },
    // 43
    { PrimoPlus: { '0': 555.53, '300': 541.78, '600': 492.21, '1200': 408.07 } },
    // 44
    { PrimoPlus: { '0': 566.89, '300': 553.52, '600': 503.1, '1200': 417.62 } },
    // 45
    { PrimoPlus: { '0': 578.49, '300': 565.49, '600': 514.24, '1200': 427.46 } },
    // 46
    { PrimoPlus: { '0': 590.45, '300': 577.84, '600': 525.81, '1200': 437.72 } },
    // 47
    { PrimoPlus: { '0': 602.71, '300': 590.5, '600': 537.73, '1200': 448.34 } },
    // 48
    { PrimoPlus: { '0': 615.24, '300': 603.43, '600': 550.01, '1200': 459.3 } },
    // 49
    { PrimoPlus: { '0': 628.12, '300': 616.73, '600': 562.7, '1200': 470.65 } },
    // 50
    { PrimoPlus: { '0': 641.18, '300': 630.21, '600': 575.62, '1200': 482.24 } },
    // 51
    { PrimoPlus: { '0': 654.53, '300': 643.99, '600': 588.88, '1200': 494.16 } },
    // 52
    { PrimoPlus: { '0': 668.11, '300': 658.01, '600': 602.4, '1200': 506.35 } },
    // 53
    { PrimoPlus: { '0': 681.89, '300': 672.23, '600': 616.17, '1200': 518.79 } },
    // 54
    { PrimoPlus: { '0': 695.89, '300': 686.69, '600': 630.16, '1200': 531.49 } },
    // 55
    { PrimoPlus: { '0': 710.19, '300': 701.45, '600': 644.5, '1200': 544.49 } },
    // 56
    { PrimoPlus: { '0': 724.84, '300': 716.57, '600': 659.25, '1200': 557.88 } },
    // 57
    { PrimoPlus: { '0': 739.88, '300': 732.09, '600': 674.42, '1200': 571.68 } },
    // 58
    { PrimoPlus: { '0': 755.24, '300': 747.93, '600': 689.95, '1200': 585.84 } },
    // 59
    { PrimoPlus: { '0': 771.05, '300': 764.24, '600': 705.96, '1200': 600.42 } },
    // 60
    { PrimoPlus: { '0': 787.16, '300': 780.86, '600': 722.33, '1200': 615.39 } },
    // 61
    { PrimoPlus: { '0': 803.54, '300': 797.75, '600': 738.95, '1200': 630.68 } },
    // 62
    { PrimoPlus: { '0': 820.17, '300': 814.9, '600': 755.83, '1200': 646.29 } },
    // 63
    { PrimoPlus: { '0': 837.05, '300': 832.31, '600': 772.97, '1200': 662.25 } },
    // 64
    { PrimoPlus: { '0': 854.28, '300': 850.09, '600': 790.48, '1200': 678.63 } },
    // 65
    { PrimoPlus: { '0': 870.64, '300': 866.98, '600': 807.16, '1200': 694.23 } },
    // 66
    { PrimoPlus: { '0': 887.32, '300': 884.21, '600': 824.18, '1200': 710.09 } },
    // 67
    { PrimoPlus: { '0': 903.98, '300': 901.4, '600': 841.26, '1200': 726 } },
    // 68
    { PrimoPlus: { '0': 920.61, '300': 918.58, '600': 858.35, '1200': 741.89 } },
    // 69
    { PrimoPlus: { '0': 937.09, '300': 935.61, '600': 875.38, '1200': 757.68 } },
    // 70
    { PrimoPlus: { '0': 953.27, '300': 952.32, '600': 892.12, '1200': 773.31 } },
];
